import { Outside } from '@cian/ui-kit';
import { DropdownPopover } from '@cian/ui-kit/popover';
import * as React from 'react';

import * as styles from './GalleryMoreMenu.css';
import { GalleryMoreMenuItem } from './GalleryMoreMenuItem';
import { ETestId } from '../../constants/testId';
import { GalleryMoreButton } from '../GalleryMoreButton';

interface IGalleryMoreMenuProps {
  onHide(): void;
  onReport(): void;
}

export const GalleryMoreMenu = ({ onHide, onReport }: IGalleryMoreMenuProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const triggerRef = React.useRef<HTMLButtonElement>(null);
  const menuRef = React.useRef<HTMLDivElement>(null);

  const close = React.useCallback(() => setIsOpen(false), []);
  const toggle = React.useCallback(() => setIsOpen(prev => !prev), []);

  const handleHide = React.useCallback(() => {
    close();
    onHide();
  }, [close, onHide]);

  const handleReport = React.useCallback(() => {
    close();
    onReport();
  }, [close, onReport]);

  const menu = (
    <Outside active={isOpen} onOutside={close} insideRefs={[triggerRef, menuRef]}>
      <div ref={menuRef} className={styles['menu']} data-testid={ETestId.GalleryMoreMenu}>
        <GalleryMoreMenuItem label="Скрыть" onClick={handleHide} dataTestId={ETestId.GalleryMoreMenuHideItem} />
        <GalleryMoreMenuItem
          label="Пожаловаться на объявление"
          onClick={handleReport}
          dataTestId={ETestId.GalleryMoreMenuReportItem}
        />
      </div>
    </Outside>
  );

  return (
    <DropdownPopover open={isOpen} content={menu} sameWidth={false}>
      <GalleryMoreButton ref={triggerRef} onClick={toggle} />
    </DropdownPopover>
  );
};
